const Styles = {
    'CheckboxFilter': 'CheckboxFilter_CheckboxFilter--272a7cff',
    'divider': 'CheckboxFilter_divider--ba7b6684',
    'CheckboxOptions': 'CheckboxFilter_CheckboxOptions--4524014e',
    'CheckboxOption': 'CheckboxFilter_CheckboxOption--2a9f07d2',
    'selectAll': 'CheckboxFilter_selectAll--fca55c47'
};

export default Styles;